import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, titles } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		marginTop: '16px',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
		overflow: 'hidden',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		backgroundColor: '#f8f9fa',
		cursor: 'pointer',
		userSelect: 'none',
		':hover': {
			backgroundColor: '#f0f0f0',
		},
	},
	headerTitle: {
		fontSize: '14px',
		fontWeight: 600,
		color: titles,
		margin: 0,
	},
	chevron: {
		width: '16px',
		height: '16px',
		color: charmGray,
		transition: 'transform 0.2s ease',
	},
	chevronExpanded: {
		transform: 'rotate(180deg)',
	},
	content: {
		maxHeight: '0',
		overflow: 'hidden',
		transition: 'max-height 0.3s ease',
	},
	contentExpanded: {
		maxHeight: '400px',
		overflowY: 'auto',
	},
	contentInner: {
		padding: '16px',
	},
	item: {
		marginBottom: '12px',
		border: `1px solid ${charmGray}`,
		borderRadius: '6px',
		overflow: 'hidden',
		':last-child': {
			marginBottom: 0,
		},
	},
	itemHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '10px 14px',
		backgroundColor: '#fafafa',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	itemHeaderContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2px',
	},
	itemTitle: {
		fontSize: '13px',
		fontWeight: 500,
		color: titles,
		margin: 0,
	},
	itemSubtitle: {
		fontSize: '11px',
		color: charmGray,
		margin: 0,
	},
	itemStatusBadge: {
		fontSize: '10px',
		padding: '2px 6px',
		borderRadius: '4px',
		fontWeight: 500,
	},
	statusComplete: {
		backgroundColor: '#e6f4ea',
		color: '#1e7e34',
	},
	statusError: {
		backgroundColor: '#fdecea',
		color: '#d93025',
	},
	statusAnalyzing: {
		backgroundColor: '#e8f0fe',
		color: brandPrimary,
	},
	itemContent: {
		padding: '14px',
		borderTop: `1px solid ${charmGray}`,
		backgroundColor: 'white',
		maxHeight: '300px',
		overflowY: 'auto',
	},
	errorText: {
		color: '#d93025',
		fontSize: '13px',
	},
});
